var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9_16719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4_10512",
    d: "M14.62 10.5086C14.62 9.19292 15.3415 7.96213 16.4449 7.28308C15.7234 6.2645 14.5775 5.62789 13.3468 5.58545C12.0311 5.45812 10.7579 6.34938 10.0788 6.34938C9.39976 6.34938 8.38118 5.58545 7.27772 5.62789C5.83473 5.67033 4.47662 6.4767 3.75513 7.74993C2.2697 10.3388 3.37316 14.2009 4.81615 16.323C5.53764 17.3416 6.38646 18.5299 7.48992 18.4875C8.55094 18.445 8.97535 17.8084 10.291 17.8084C11.6067 17.8084 11.9462 18.4875 13.0921 18.4875C14.238 18.445 15.0019 17.4264 15.681 16.4079C16.1903 15.6439 16.5723 14.8375 16.8693 13.9887C15.5112 13.3946 14.62 12.0365 14.62 10.5086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4_10513",
    d: "M12.4553 4.22744C13.092 3.46351 13.4315 2.48737 13.3466 1.51123C12.3705 1.59611 11.4792 2.06296 10.8426 2.78445C10.206 3.50595 9.86646 4.43965 9.95134 5.41579C10.9275 5.45823 11.8612 4.99138 12.4553 4.22744Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApple);
export default __webpack_public_path__ + "static/media/ic_apple.6ae3bbd0793cb14ab7e938eba069d33a.svg";
export { ForwardRef as ReactComponent };